/**
 * Arabic About Translations
 * 关于页翻译模块 - 阿拉伯语
 * 
 * 包含公司介绍、发展历程、使命价值观、认证专利等翻译
 */

import type { AboutTranslations } from '../../types';

export const arAbout: AboutTranslations = {
  title: 'من نحن',
  subtitle: 'نبتكر الراحة من أجل مستقبل مستدام.',
  header: {
    title: 'عن JH للتدفئة',
    subtitle: 'نبتكر الراحة من أجل مستقبل مستدام.',
  },
  history: {
    title: 'تاريخنا',
    desc: 'تأسست شركة فوجيان جينغهو للتكنولوجيا البيئية (JH Heatsup) في عام 2006، بدأت برؤية بسيطة: خلق حلول تدفئة وتبريد ليست قوية فحسب، بل مسؤولة بيئيًا أيضًا. تقع في حديقة فوتشو للتقنية العالية المزدهرة، نما من فريق بحث وتطوير صغير إلى شركة تصنيع عالمية.',
    timelineTitle: 'محطات تطور التدفئة بالأشعة تحت الحمراء',
    timelineDesc: 'ست محطات توثق تطورنا من أولى سلاسل الأشعة تحت الحمراء البعيدة إلى حلول الحمامات المتصلة وسريعة التسخين.',
    milestones: [
      { year: '2013', title: 'بدء إنتاج الأشعة تحت الحمراء', desc: 'دخلت سخانات الإشعاع بالأشعة تحت الحمراء البعيدة من سلسلتي 13A و13B مرحلة الإنتاج.' },
      { year: '2015', title: 'توسيع مجموعة المنتجات', desc: 'أطلقنا سلاسل سخانات الأشعة تحت الحمراء البعيدة 14A/14B و15A/15B.' },
      { year: '2017', title: 'التدفئة تلتقي بالبلوتوث', desc: 'طُرحت سلسلة JH13C مع مكبر صوت Bluetooth مدمج.' },
      { year: '2018', title: 'حلول لمساحات أكثر', desc: 'طُرحت سخانات الألواح السفلية وبدأ إنتاج سخانات الحمامات بالأشعة تحت الحمراء البعيدة.' },
      { year: '2019', title: 'تدفئة ذكية عبر Wi-Fi', desc: 'طُرحت سلسلة 13W المتصلة بوظيفة Wi-Fi مدمجة.' },
      { year: '2021', title: 'تدفئة الحمام في خمس ثوانٍ', desc: 'طورنا سخان حمام بلوح زجاجي قادرًا على التسخين خلال خمس ثوانٍ فقط.' },
    ],
  },
  mission: {
    title: 'مهمتنا',
  },
  quality: {
    title: 'ضمان الجودة',
    desc: 'عمليات معتمدة ISO9001. يتم اختبار كل مدفأة قبل مغادرة المصنع.',
  },
  values: {
    title: 'قيمنا الأساسية',
    sustainability: {
      title: 'الاستدامة والابتكار',
      desc: 'نبتكر تقنيات توفير الطاقة لتقليل البصمة الكربونية وتعظيم كفاءة التدفئة.',
    },
    quality: {
      title: 'الجودة المعتمدة',
      desc: 'مصنوع في مرافق حاصلة على شهادة ISO9001 واختبار صارم لضمان الأداء الممتاز.',
    },
    customerFirst: {
      title: 'الثقة والشراكة العالمية',
      desc: 'موثوق من قبل أكثر من 800 شريك عالمي في أكثر من 100 دولة، نبني علاقات طويلة المدى من خلال خدمة تركز على العميل.',
    },
  },
  features: {
    title: 'مزايا المنتج',
    fast: {
      title: 'تسخين سريع',
      desc: 'تسخين سريع بفضل تقنية الأشعة تحت الحمراء عالية الكفاءة.',
    },
    energy: {
      title: 'توفير الطاقة',
      desc: 'تحكم ذكي يساعد على تقليل تكاليف التدفئة.',
    },
    healthy: {
      title: 'راحة صحية',
      desc: 'دفء إشعاعي دون تجفيف الهواء لمزيد من الراحة.',
    },
    safe: {
      title: 'آمن وموثوق',
      desc: 'حمايات متعددة للسلامة لراحة بالك.',
    },
  },
  companyProfile: {
    title: 'ملف الشركة',
    desc: 'شركة فوجيان جينغهو للتكنولوجيا البيئية، المعروفة سابقًا باسم شركة فوجيان جينغهو للتكنولوجيا البيئية، تأسست في عام 2006 ومقرها في فوتشو، الصين. نحن شركة تقنية عالية متخصصة في البحث والإنتاج أجهزة تدفئة بالإشعاع تحت الأحمر البعيد، ملتزمة بفلسفة العمل "السعي نحو التميز، لخلق التميز معًا"، مكرسة لتوفير حلول تدفئة فعالة وموفرة للطاقة وصحية ومريحة للمستخدمين في جميع أنحاء العالم.',
  },
  services: {
    title: 'الخدمات المهنية',
    desc: 'لدينا مهندسون تقنيون محترفون وموظفون مبيعات ذوو خبرة لتوفير خدمات عالية الجودة لك في تطبيقات التبريد/التدفئة الصناعية والتجارية، مثل توفير منتجات عالية الجودة وحلول جيدة لدرجة حرارة مريحة ورطوبة وهواء نقي في ورش المصانع والمراكز التجارية والصالات الرياضية والمقاهي والدفيئات والمناطق الخارجية والأماكن الأخرى.',
  },
  technology: {
    title: 'التقنية الرائدة',
    desc: 'نطبق طلاء النانو سيراميك على أجهزة تدفئة بالإشعاع تحت الأحمر البعيد، مما يغير مشاكل تغير اللون والتقشر السهل للطلاء لأجهزة التدفئة التقليدية، مما يجعل الإشعاع أكثر كفاءة وسرعة. توفر تقنيتنا المتقدمة بالأشعة تحت الحمراء البعيدة تسخينًا سريعًا وتوزيعًا متساويًا للحرارة لبيئة معيشية دافئة ومريحة.',
    nanoCeramic: { title: 'تقنية النانو سيراميك', desc: 'كفاءة إشعاع محسّنة لتسخين أسرع' },
    farInfrared: { title: 'إشعاع الأشعة تحت الحمراء البعيدة', desc: 'توزيع حراري متساوٍ للراحة' },
  },
  certifications: {
    title: 'الشهادات وبراءات الاختراع',
    desc: 'حصلنا على أكثر من 32 براءة اختراع للمظهر والنماذج الاختراعية والاختراعات. منتجاتنا متوافقة مع معايير الشهادات safety الدولية مثل CCC و ISO9001:2015 و CE و CB و SAA و EMC و SASO، مما يضمن ضمان الجودة.',
  },
  clients: {
    title: 'العملاء العالميون',
    desc: 'تم تصدير منتجات التدفئة الخاصة بنا إلى أكثر من 100 دولة ومنطقة حول العالم، وموثوق بها من قبل المستخدمين عالميًا.',
    export: 'التصدير إلى أكثر من 100 دولة ومنطقة',
    agents: 'أكثر من 800 وكيل دولي',
    trusted: 'موثوق به من قبل المستخدمين عالميًا',
    showcaseTitle: 'ثقة شركائنا حول العالم',
    showcaseDesc: 'نلتقي في المعارض الدولية وجهاً لوجه مع الموزعين ومشتري المشاريع والمتخصصين في القطاع من مختلف أنحاء العالم. تساعدنا هذه اللقاءات على فهم احتياجات التدفئة في كل سوق، وعرض أحدث حلول الأشعة تحت الحمراء، وبناء شراكات طويلة الأمد من خلال منتجات موثوقة وجودة ثابتة ودعم سريع الاستجابة.',
  },
  manufacturing: {
    title: 'قدرة التصنيع',
    desc: 'لدينا ورشة إنتاج بمساحة 4500 متر مربع مع أكثر من 150 مهندسًا تقنيًا وعمالًا ماهرين، مع قدرة إنتاج شهرية تتجاوز 10000 منتج تدفئة. لدينا القدرة على إكمال كل طلب في الوقت المحدد بالجودة والكمية.',
    workshopArea: 'مساحة الورشة',
    engineersWorkers: 'المهندسون والعمال',
    monthlyCapacity: 'السعة الإنتاجية الشهرية',
    patents: 'براءات الاختراع',
  },
  ceo: {
    title: 'مؤسسنا',
    name: 'السيدة هوانغ شيوفانغ',
    role: 'المؤسسة',
    desc: 'السيدة هوانغ شيوفانغ هي واحدة من أوائل الباحثين والمصممين لأجهزة التدفئة بالأشعة تحت الحمراء البعيدة في الصين. في عام 2003، عملت مع مجموعة من الشركاء المتحمسين لتقنية التدفئة لتطوير وتصميم products التبخر. في عام 2006، أسست شركة فوجيان جينغهو للتكنولوجيا البيئية. في عام 2011، قادت فريق البحث والتطوير لتصميم أجهزة تدفئة بالأشعة تحت الحمراء البعيدة من النوع اللوحى، ببراعة دمج أجهزة التحكم الذكية ومكبرات الصوت Bluetooth و WiFi في أجهزة التدفئة، مما يجعلها ليست مجرد أجهزة تدفئة، بل نمط حياة. كل تفصيل تصميم يعكس مزجها للجمال الغربي مع السحر الشرقى، مما يمنح المنتجات حيوية نابضة بالحياة.',
    quote: '"نحن ملتزمون بخلق عالم أكثر خضرة ودفئًا من خلال التكنولوجيا."',
  },
  applications: {
    title: 'سيناريوهات التطبيق',
    desc: 'تستخدم أجهزة التدفئة بالأشعة تحت الحمراء البعيدة على نطاق واسع في سيناريوهات مختلفة، مما يوفر حلول تدفئة شاملة لك',
    restaurant: {
      title: 'المطعم',
      desc: '',
      icon: 'Utensils',
    },
    livingRoom: {
      title: 'غرفة المعيشة',
      desc: '',
      icon: 'Sofa',
    },
    office: {
      title: 'المكتب',
      desc: '',
      icon: 'Building',
    },
    patio: {
      title: 'الشرفة',
      desc: '',
      icon: 'Sun',
    },
    sauna: {
      title: 'غرفة السونا',
      desc: '',
      icon: 'Flame',
    },
    garage: {
      title: 'الجراج',
      desc: '',
      icon: 'Warehouse',
    },
    balcony: {
      title: 'صالة الألعاب الرياضية',
      desc: '',
      icon: 'Dumbbell',
    },
    entertainment: {
      title: 'غرفة الترفيه',
      desc: '',
      icon: 'Gamepad2',
    },
  },
};
